import { Divider } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import SwitchSettings from "./SwitchSettings";
import PasswordUpdate from "./PasswordUpdate";

export default function ProfileTab() {
  const { t } = useTranslation();

  return (
    <>
      <Divider orientation="left">{t("updatePassword")}</Divider>
      <PasswordUpdate />
      <Divider orientation="left">{t("notifications")}</Divider>
      <SwitchSettings  />
    </>
  );
}
